export default __webpack_public_path__ + "static/hero-image-3-859db4c2df2c109684ed460b419ca8aa.jpg";